export default [
  {
    path: '/home',
    name: 'home.index',
    component: () => import('@/views/Home/Index.vue'),
  },

  {
    path: '/alle-gerichte',
    name: 'home.all-ordered-articles',
    component: () => import('@/views/Home/LatestOrderedArticles.vue'),
  },

  {
    path: '/jetzt-bestellen',
    name: 'home.last-form',
    component: () => import('@/views/Home/LastForm.vue'),
  },

  {
    path: '/sepa',
    name: 'sepa.index',
    component: () => import('@/views/Home/Sepa.vue'),
  },

  {
    path: '/verify-sepa/:token',
    name: 'verify-sepa.index',
    component: () => import('@/views/Home/VerifySepa'),
  },

  // Guest Routes
  {
    path: '/login',
    name: 'login.index',
    component: () => import('@/views/Login/Index'),
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/qr-work-start',
    name: 'login.work-time-start',
    component: () => import('@/views/Login/WorkTimeStart'),
  },

  {
    path: '/qr-work-stop',
    name: 'login.work-time-stop',
    component: () => import('@/views/Login/WorkTimeStop'),
  },

  // Register
  {
    path: '/register',
    name: 'register.index',
    component: () => import('@/views/Register/Index.vue'),
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/iframe-register',
    name: 'register.iframe',
    component: () => import('@/views/Register/Iframe.vue'),
  },

  {
    path: '/forgot-password',
    name: 'forgot.index',
    component: () => import('@/views/Login/Forgot'),
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/resend-verification',
    name: 'resend.index',
    component: () => import('@/views/Login/ResendVerification'),
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/reset-password/:token',
    name: 'reset.index',
    component: () => import('@/views/Login/Reset'),
    meta: {
      perimeter: 'GuestPerimeter',
    },
  },

  {
    path: '/email-verify/:token',
    name: 'verify.index',
    component: () => import('@/views/Login/Verify'),
  },

  {
    path: '/probieren',
    name: 'orders.try-out',
    component: () => import('@/views/Orders/TryOut'),
  },

  {
    path: '/orders/:slug',
    name: 'orders.form',
    component: () => import('@/views/Orders/Form'),
  },

  {
    path: '/orders-v2/:slug',
    name: 'orders.form.v2',
    component: () => import('@/views/Orders/FormV2'),
  },

  {
    path: '/kaufen',
    name: 'purchases.form',
    component: () => import('@/views/Purchases/Form'),
  },

  {
    path: '/impressum',
    name: 'impressum.index',
    component: () => import('@/views/Home/Impressum'),
  },

  {
    path: '/datenschutz',
    name: 'datenschutz.index',
    component: () => import('@/views/Home/Datenschutz'),
  },

  {
    path: '/report-a-problem',
    name: 'problem.index',
    component: () => import('@/views/Home/Problem'),
  },

  {
    path: '/',
    redirect: '/home',
  },

  {
    path: '/*',
    name: 'not-found',
    component: () => import('@/views/Errors/404.vue'),
  },
];



// WEBPACK FOOTER //
// ./src/routes/guest.js